/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prop_CreatedInputs */

const en_prop_created = /** @type {(inputs: Prop_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const de_prop_created = /** @type {(inputs: Prop_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt`)
};

/**
* | output |
* | --- |
* | "Created" |
*
* @param {Prop_CreatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const prop_created = /** @type {((inputs?: Prop_CreatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prop_CreatedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_prop_created(inputs)
	return en_prop_created(inputs)
});